// @ts-nocheck

import combineReducers from '../../../utils/combineReducers';
import type { GridsState } from '../types';

import basketReducers, { initialState as basketInitialState } from './basket';
import historyReducers, { initialState as historyInitialState } from './history';
import publicReducers, { initialState as publicInitialState } from './public';
import uiReducers, { initialState as uiInitialState } from './ui';

export const gridInitialState: GridsState = {
  basket: basketInitialState,
  history: historyInitialState,
  publicGrids: publicInitialState,
  ui: uiInitialState,
};

export default combineReducers({
  publicGrids: publicReducers,
  history: historyReducers,
  basket: basketReducers,
  ui: uiReducers,
});
